import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { ScrollToTop } from '../ScrollToTop';
import { Seo } from '../common/Seo';
import ErrorBoundary from '../common/ErrorBoundary';
import { useAnalytics } from '../../hooks/useAnalytics';

/**
 * Layout komponenta - zajišťuje jednotný layout pro všechny stránky
 * Obsahuje Navbar, ScrollToTop, Footer, SEO a Analytics
 */
export const Layout = ({ children }) => {
  const location = useLocation();
  useAnalytics();

  return (
    <ErrorBoundary>
      <div className="App">
        <Seo />
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen">
          {children}
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  );
};

